<ng-container [ngSwitch]="skeletonRoute">
  <ng-container *ngSwitchCase="'self-reaccommodation/retrieve'">
    <ng-container *ngTemplateOutlet="retrieveSkeleton"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'self-reaccommodation/availability'">
    <ng-container *ngTemplateOutlet="availabilitySkeleton">
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'refund'">
    <ng-container *ngTemplateOutlet="refundReviewSkeleton">
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'refund/review'">
    <ng-container *ngTemplateOutlet="refundReviewSkeleton">
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #retrieveSkeleton>
  <refx-basic-layout>
    <refx-page-title-skeleton-pres pageHeader
      [displaySubtitleSkeleton]="false">
    </refx-page-title-skeleton-pres>
    <div messagePanel>
      <refx-messages-panel-skeleton-pres class="messages-panel-skeleton">
      </refx-messages-panel-skeleton-pres>
    </div>
    <div mainContent>
      <div class="identification-card">
        <refx-identification-skeleton-pres></refx-identification-skeleton-pres>
      </div>
    </div>
  </refx-basic-layout>
</ng-template>

<ng-template #availabilitySkeleton>
  <refx-basic-layout>
    <refx-collapsible-information-panel-skeleton-pres collapsiblePanel>
    </refx-collapsible-information-panel-skeleton-pres>
    <section class="breadcrumb-skeleton-container" breadcrumb>
      <refx-breadcrumb-skeleton-pres [nbSteps]="3"></refx-breadcrumb-skeleton-pres>
    </section>
    <refx-page-title-skeleton-pres pageHeader
      [displaySubtitleSkeleton]="true">
    </refx-page-title-skeleton-pres>
    <div mainContent>
      <refx-calendar-skeleton-pres>
      </refx-calendar-skeleton-pres>
      <refx-alternative-offers-availability-skeleton-pres [nbRows]="5"></refx-alternative-offers-availability-skeleton-pres>
    </div>
  </refx-basic-layout>
</ng-template>

<ng-template #refundReviewSkeleton>
  <refx-basic-layout>
    <refx-page-title-skeleton-pres pageHeader
      [displaySubtitleSkeleton]="false">
    </refx-page-title-skeleton-pres>
    <div messagePanel>
      <refx-messages-panel-skeleton-pres class="messages-panel-skeleton refund-message-skeleton">
      </refx-messages-panel-skeleton-pres>
    </div>
    <div mainContent>
      <refx-itinerary-card-skeleton-pres
        [nbBounds]="nbBounds">
      </refx-itinerary-card-skeleton-pres>
      <refx-passenger-recap-skeleton-pres
        [travelers]="travelers">
      </refx-passenger-recap-skeleton-pres>
      <div class="refund-details-container">
        <ngx-skeleton-loader class="refund-title-skeleton"></ngx-skeleton-loader>
        <refx-refund-preview-skeleton-pres></refx-refund-preview-skeleton-pres>

        <ngx-skeleton-loader class="refund-method-title-skeleton"></ngx-skeleton-loader>
        <refx-refund-method-skeleton-pres></refx-refund-method-skeleton-pres>
      </div>
    </div>
    <div footer>
      <ngx-skeleton-loader class="refund-amount-skeleton"></ngx-skeleton-loader>
      <div class="buttons-skeleton-container">
        <ngx-skeleton-loader class="buttons-skeleton" count="2"></ngx-skeleton-loader>
      </div>
    </div>
  </refx-basic-layout>
</ng-template>
